module.exports = __webpack_public_path__ + "static/punta_gaira-0c8c5ffc0740508a19becebac641cbe2.jpg";